export default {
  "widget.defaultTitle": "Bizimle sohbet edin",
  "widget.defaultSubtitle": "Size yardımcı olmak için buradayız",
  "widget.defaultGreeting": "Merhaba! Bugün size nasıl yardımcı olabiliriz?",
  "chat.close": "Sohbeti kapat",
  "chat.open": "Sohbeti aç",
  "chat.expand": "Sohbeti genişlet",
  "chat.collapse": "Sohbeti daralt",
  "chat.conversationEnded": "Bu görüşme sona erdi",
  "chat.startNew": "Yeni Görüşme Başlat",
  "chat.poweredBy": "Altyapı",
  "chat.conversationClosed": "Görüşme Kapandı",
  "chat.aiLabel": "Yapay zekâ asistanı",
  "input.placeholder": "Bir mesaj yazın...",
  "input.send": "Mesaj gönder",
  "error.sendFailed": "Mesajınız gönderilemedi. Lütfen birazdan tekrar deneyin.",
  "error.messageTooLong": "Mesajınız çok uzun. Lütfen kısaltıp tekrar deneyin.",
  "chat.teamMember": "Bir ekip üyesi",
  "chat.agentJoined": "{name} sohbete katıldı",
  "chat.agentLeft": "{name} sohbetten ayrıldı",
  "chat.agentReturnedToAi":
    "{name} sohbetten ayrıldı. Yeniden yapay zekâ asistanıyla sohbet ediyorsunuz.",
  "availability.open": "Şu an açık",
  "availability.backAt": "Dönüş: {when}",
  "availability.closed": "Şu an mesai dışı",
  "waiting.title": "Bir kişiyi bekliyorsunuz",
  "waiting.typical": "Genellikle {time} içinde yanıt verir",
  "waiting.alerted": "Ekibe haber verdik.",
  "waiting.closed":
    "Ekip {when} dönüyor. O zamana kadar yapay zekâ asistanı yardım etmeye devam edebilir.",
  "waiting.minutes": "~{n} dk",
  "waiting.hours": "~{n} sa",
  "contact.prompt": "E-postanızı bırakın, ayrılmış olursanız ekibin yanıtını oraya gönderelim.",
  "contact.label": "E-posta",
  "contact.placeholder": "siz@ornek.com",
  "contact.submit": "Bana haber ver",
  "contact.consent": "E-postanızı yalnızca bu konuşmayı yanıtlamak için kullanacağız.",
  "contact.saved":
    "Teşekkürler! Ekip yanıt verdiğinde ayrılmış olursanız size e-posta göndereceğiz.",
  "contact.failed": "E-postanız kaydedilemedi. Lütfen kontrol edip tekrar deneyin.",
  "input.attach": "Fotoğraf veya PDF ekle",
  "error.fileTooLarge": "Bu dosya çok büyük. En fazla 10 MB fotoğraf ve PDF.",
  "error.fileType": "Fotoğraf (JPG, PNG, GIF, WebP) veya PDF gönderebilirsiniz.",
  "error.fileFailed": "Dosyanız gönderilemedi. Lütfen başka bir dosya deneyin.",
  "attachment.photo": "Fotoğraf",
  "attachment.file": "Dosya",
  "attachment.sending": "Gönderiliyor...",
  "error.verificationFailed": "Mesajınızı doğrulayamadık. Lütfen sayfayı yenileyip tekrar deneyin.",
  "challenge.label": "Güvenlik kontrolü",
  "challenge.prompt": "Mesajınızı göndermeden önce kısa bir güvenlik kontrolü.",
  "csat.defaultQuestion": "Bugün aldığınız desteği nasıl değerlendirirsiniz?",
  "csat.thankYou": "Geri bildiriminiz için teşekkürler!",
} as const;
